import { State } from '.';
import { PaymentCard } from '../../models/payment-card';

export const selectors = {
    getLoading: (
        state: State,
        loadingKey: string
    ): boolean => state.loading[loadingKey] || false,
    getPaymentCard: (
        state: State,
        id: Undefinable<DictionaryKey>
    ): Undefinable<PaymentCard> => state.byId[id === 'primary' ? state.primaryId : (id || '')],
    getPaymentCardIds: (
        state: State
    ): string[] => state.allIds,
    getPrimaryCardId: (
        state: State
    ): string => state.primaryId
};
